(function () {
  function clamp(n, a, b) {
    return Math.max(a, Math.min(b, n));
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  function parseInitialActive(root, fallbackSlideIdx) {
    var v = parseInt(root.getAttribute("data-initial-active"), 10);
    return isNaN(v) ? fallbackSlideIdx : v;
  }

  function pad2(n) {
    return n < 10 ? "0" + n : String(n);
  }

  var W_CENTER = 560;
  var H_CENTER = 320;
  var W_SIDE_INNER = 420;
  var H_SIDE_INNER = 240;
  var W_SIDE_OUTER = 320;
  var H_SIDE_OUTER = 183;
  var GAP = 32;
  var COLLAPSE_OVERLAP = 140;
  var INNER_PEEK = 0.42;
  var COLLAPSED_SIDE_MIN_ABS = 260;
  var SCROLL_EXPAND_BOOST = 1.52;
  var CTA_EXPAND_CAP_UNTIL_COPY_VISIBLE = 0.84;

  /* AUTOPLAY CONFIG (slightly slower) */
  var AUTOPLAY_MS = 4200;
  var AUTOPLAY_PAUSE_MS = 6000;

  function readStickyTopInsetPx(root) {
    var sticky = root.querySelector(".oct__sticky");
    if (!sticky) return 0;
    var n = parseFloat(getComputedStyle(sticky).top);
    return isNaN(n) ? 0 : n;
  }

  function isOctKickerCopyVisible(root) {
    var topInset = readStickyTopInsetPx(root);
    var vh = window.innerHeight || 1;
    var eb = root.querySelector(".oct__eyebrow");
    if (eb) {
      var er = eb.getBoundingClientRect();
      if (er.width > 0 || er.height > 0) {
        var vTop = Math.max(er.top, topInset);
        var vBottom = Math.min(er.bottom, vh);
        var h = vBottom - vTop;
        var need = Math.min(26, Math.max(14, er.height * 0.22));
        return h >= need;
      }
    }
    var sels = [".oct__title", ".oct__intro"];
    var si;
    for (si = 0; si < sels.length; si++) {
      var el = root.querySelector(sels[si]);
      if (!el) continue;
      var r = el.getBoundingClientRect();
      if (r.width <= 0 && r.height <= 0) continue;
      var vt = Math.max(r.top, topInset);
      var vb = Math.min(r.bottom, vh);
      var hh = vb - vt;
      var nd = Math.min(26, Math.max(14, r.height * 0.22));
      if (hh >= nd) return true;
    }
    return false;
  }

  function slotOfSlide(slots, slideIdx) {
    var s;
    for (s = 0; s < slots.length; s++) if (slots[s] === slideIdx) return s;
    return 0;
  }

  function rotateSlotsLeft(slots, k, n) {
    if (n <= 0 || k <= 0) return;
    k = k % n;
    if (k === 0) return;
    var copy = slots.slice();
    var i;
    for (i = 0; i < n; i++) slots[i] = copy[(i + k) % n];
  }

  function rotateSlotsRight(slots, k, n) {
    if (n <= 0 || k <= 0) return;
    k = k % n;
    if (k === 0) return;
    var copy = slots.slice();
    var i;
    for (i = 0; i < n; i++) slots[i] = copy[(i - k + n * n) % n];
  }

  function rotateSlotsToBringSlideToCenter(slots, centerSlot, clickedSlideIdx, n) {
    var s = slotOfSlide(slots, clickedSlideIdx);
    if (s === centerSlot) return;
    if (s > centerSlot) rotateSlotsLeft(slots, s - centerSlot, n);
    else rotateSlotsRight(slots, centerSlot - s, n);
  }

  function cardSizeForSlot(s, centerSlot) {
    var dist = Math.abs(s - centerSlot);
    if (dist === 0) return { w: W_CENTER, h: H_CENTER };
    if (dist === 1) return { w: W_SIDE_INNER, h: H_SIDE_INNER };
    return { w: W_SIDE_OUTER, h: H_SIDE_OUTER };
  }

  function centersExpandedRaw(n, ms, centerSlot) {
    var widths = [];
    var s;
    for (s = 0; s < n; s++) {
      widths.push(Math.round(cardSizeForSlot(s, centerSlot).w * ms));
    }
    var g = Math.round(GAP * ms);
    var total = 0;
    for (s = 0; s < n; s++) total += widths[s];
    total += g * (n - 1);

    var x = -total / 2;
    var centers = [];
    for (s = 0; s < n; s++) {
      x += widths[s] / 2;
      centers[s] = x;
      x += widths[s] / 2 + g;
    }
    return { centers: centers, widths: widths };
  }

  function fitCentersToStage(centers, widths, maxSpanPx) {
    if (!centers.length || maxSpanPx <= 0) return centers.slice();
    var minL = Infinity;
    var maxR = -Infinity;
    var i;
    for (i = 0; i < centers.length; i++) {
      var h = widths[i] / 2;
      minL = Math.min(minL, centers[i] - h);
      maxR = Math.max(maxR, centers[i] + h);
    }
    var span = maxR - minL;
    if (span <= maxSpanPx) return centers.slice();
    var factor = (maxSpanPx / span) * 0.986;
    var out = [];
    for (i = 0; i < centers.length; i++) out[i] = centers[i] * factor;
    return out;
  }

  function centersCollapsed(centerSlot, n, ms, c1full) {
    var wc = Math.round(W_CENTER * ms);
    var ws = Math.round(W_SIDE_INNER * ms);
    var ov = Math.round(COLLAPSE_OVERLAP * ms);
    var leftX = -(wc / 2 + ws / 2 - ov);
    var rightX = wc / 2 + ws / 2 - ov;

    var centers = [];
    var s;
    for (s = 0; s < n; s++) {
      var off = s - centerSlot;
      if (off === 0) centers[s] = 0;
      else if (off === -1) {
        var tgt = c1full[s];
        var peek = lerp(0, tgt, INNER_PEEK);
        var looseL = Math.max(peek, leftX);
        var minL = -Math.round(COLLAPSED_SIDE_MIN_ABS * ms);
        centers[s] = Math.min(looseL, minL);
      } else if (off === 1) {
        var tgtR = c1full[s];
        var peekR = lerp(0, tgtR, INNER_PEEK);
        var looseR = Math.min(peekR, rightX);
        var minR = Math.round(COLLAPSED_SIDE_MIN_ABS * ms);
        centers[s] = Math.max(looseR, minR);
      } else if (off === -2 || off === 2) centers[s] = 0;
      else centers[s] = off < 0 ? -1400 : 1400;
    }
    return centers;
  }

  function init(root) {
    var track = root.querySelector(".oct__track");
    var stage = root.querySelector("[data-oct-slides]");
    var slides = Array.prototype.slice.call(root.querySelectorAll("[data-oct-slide]"));
    var btn = root.querySelector("[data-oct-btn]");
    var counter = root.querySelector("[data-oct-counter]");
    var defaultBtn = root.getAttribute("data-default-btn-label") || "View Collections";

    if (!track || !stage || slides.length === 0) return;

    var stageRail = root.querySelector(".oct__stage");
    var n = slides.length;
    var centerSlot = Math.floor((n - 1) / 2);

    var slots = [];
    var i;
    for (i = 0; i < n; i++) slots[i] = i;

    var initialSlide = clamp(parseInitialActive(root, centerSlot), 0, n - 1);
    if (initialSlide !== slots[centerSlot]) {
      rotateSlotsToBringSlideToCenter(slots, centerSlot, initialSlide, n);
    }

    var mobileActive = slots[centerSlot];
    var prevBtn = root.querySelector("[data-oct-prev]");
    var nextBtn = root.querySelector("[data-oct-next]");
    var lastMobile = window.matchMedia("(max-width: 749px)").matches;

    var autoplayTimer = null;
    var autoPauseTimer = null;

    function isMobile() {
      return window.matchMedia("(max-width: 749px)").matches;
    }

    function isInViewport() {
      var rect = root.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      return rect.top < vh && rect.bottom > 0;
    }

    /* Resolve the button label for a given slide: custom per-slide label,
       falling back to the section default. */
    function btnLabelForSlide(slideEl) {
      if (slideEl) {
        var lbl = slideEl.getAttribute("data-btn-label");
        if (lbl && lbl.trim() !== "") return lbl;
      }
      return defaultBtn;
    }

    /* Apply the CTA button color of a given slide (always, any state) */
    function applyBtnColorForSlide(slideEl) {
      if (!btn || !slideEl) return;
      var bg = slideEl.getAttribute("data-cta-bg");
      var fg = slideEl.getAttribute("data-cta-fg");
      if (bg) btn.style.setProperty("background-color", bg);
      else btn.style.removeProperty("background-color");
      if (fg) btn.style.setProperty("color", fg);
      else btn.style.removeProperty("color");
    }

    function autoAdvance() {
      if (!isInViewport()) return;

      if (isMobile()) {
        mobileActive = (mobileActive + 1) % n;
        applyLayout();
      } else {
        if (expand < 0.9) return;
        var rightInnerSlideIdx = slots[centerSlot + 1] !== undefined
          ? slots[centerSlot + 1]
          : slots[(centerSlot + 1) % n];
        beginSlotShuffleAnim(rightInnerSlideIdx);
      }
    }

    function startAutoplay() {
      stopAutoplay();
      autoplayTimer = setInterval(autoAdvance, AUTOPLAY_MS);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function pauseAndResume() {
      stopAutoplay();
      if (autoPauseTimer) clearTimeout(autoPauseTimer);
      autoPauseTimer = setTimeout(startAutoplay, AUTOPLAY_PAUSE_MS);
    }

    function syncSlotsFromMobileView() {
      var j;
      for (j = 0; j < n; j++) slots[j] = j;
      if (mobileActive !== slots[centerSlot]) {
        rotateSlotsToBringSlideToCenter(slots, centerSlot, mobileActive, n);
      }
    }

    function clearSlideLayoutStyles(el) {
      el.style.removeProperty("left");
      el.style.removeProperty("top");
      el.style.removeProperty("transform");
      el.style.removeProperty("opacity");
      el.style.removeProperty("z-index");
      el.style.removeProperty("pointer-events");
      el.style.removeProperty("--oct-card-w");
      el.style.removeProperty("--oct-card-h");
    }

    var expand = 0;
    var userInteracted = false;
    var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var SLOT_ANIM_MS = 900;

    function clearSlotAnim() {
      if (root._octSlotAnimTimer) {
        clearTimeout(root._octSlotAnimTimer);
        root._octSlotAnimTimer = null;
      }
      root.classList.remove("oct--slot-animating");
      root.classList.remove("oct--fading");
    }

    function beginSlotShuffleAnim(clickedIdx) {
      if (root.classList.contains("oct--slot-animating")) return;
      rotateSlotsToBringSlideToCenter(slots, centerSlot, clickedIdx, n);
      applyLayout();
    }

    function mobileScale() { return 1; }

    function stageMaxSpanPx() {
      var box = stageRail || stage;
      var sw = box.clientWidth || box.getBoundingClientRect().width || stage.offsetWidth || root.offsetWidth || 1200;
      var buf = 28;
      return Math.max(240, Math.floor(sw * 0.88) - buf);
    }

    function slideElByIndex(idx) {
      var el;
      for (var k = 0; k < slides.length; k++) {
        el = slides[k];
        if (parseInt(el.getAttribute("data-index"), 10) === idx) return el;
      }
      return slides[idx];
    }

    function applyLayout() {
      var mobile = isMobile();
      root.classList.toggle("oct--mobile", mobile);

      if (mobile) {
        clearSlotAnim();
        var j;
        for (j = 0; j < n; j++) {
          var mel = slideElByIndex(j);
          if (!mel) continue;
          clearSlideLayoutStyles(mel);
          mel.classList.toggle("oct__slide--mobile-active", j === mobileActive);
          mel.removeAttribute("data-side");
        }

        if (prevBtn) {
          prevBtn.disabled = n <= 1;
          prevBtn.style.visibility = n <= 1 ? "hidden" : "";
        }
        if (nextBtn) {
          nextBtn.disabled = n <= 1;
          nextBtn.style.visibility = n <= 1 ? "hidden" : "";
        }

        var mcur = slideElByIndex(mobileActive);
        if (counter) {
          var mnum = mobileActive + 1;
          counter.textContent = pad2(mnum);
          var tslides = parseInt(counter.getAttribute("data-slide-count"), 10) || n;
          counter.setAttribute("aria-label", "Slide " + mnum + " of " + tslides);
          counter.setAttribute("aria-hidden", "true");
        }

        if (btn && mcur) {
          var murl = mcur.getAttribute("data-url") || "";
          var mfallback = btn.getAttribute("href") || "#";
          if (murl) btn.setAttribute("href", murl);
          else btn.setAttribute("href", mfallback);
          var mtxt = btn.querySelector(".oct__btn-text");
          if (mtxt) mtxt.textContent = btnLabelForSlide(mcur);
          /* Button color always reflects active slide (mobile) */
          applyBtnColorForSlide(mcur);
        }

        root.classList.remove("oct--expanded", "oct--interactive");
        return;
      }

      slides.forEach(function (mel) { mel.classList.remove("oct__slide--mobile-active"); });

      var expandGeom = reduced ? 1 : expand;
      var copyOk = isOctKickerCopyVisible(root);
      var expandCta = expandGeom >= 0.98 || copyOk ? expandGeom : Math.min(expandGeom, CTA_EXPAND_CAP_UNTIL_COPY_VISIBLE);
      var u = easeOutCubic(expandGeom);
      var ms = mobileScale();

      var raw = centersExpandedRaw(n, ms, centerSlot);
      var c1full = fitCentersToStage(raw.centers, raw.widths, stageMaxSpanPx());
      var c0 = centersCollapsed(centerSlot, n, ms, c1full);

      var interactive = expandGeom > 0.92;
      root.classList.toggle("oct--expanded", expandCta > 0.85);
      root.classList.toggle("oct--interactive", interactive);

      var centerSlideIdx = slots[centerSlot];

      for (i = 0; i < n; i++) {
        var el = slideElByIndex(i);
        if (!el) continue;

        var s = slotOfSlide(slots, i);
        var cx = lerp(c0[s], c1full[s], u);
        var sz = cardSizeForSlot(s, centerSlot);
        var w = Math.round(sz.w * ms);
        var h = Math.round(sz.h * ms);
        var off = Math.abs(s - centerSlot);

        el.style.left = "calc(50% + " + cx + "px)";
        el.style.top = "50%";
        el.style.transform = "translate(-50%, -50%)";
        el.style.setProperty("--oct-card-w", w + "px");
        el.style.setProperty("--oct-card-h", h + "px");

        var op = 1;
        if (off >= 2) op = lerp(0, 1, u);
        el.style.opacity = String(op);
        el.style.pointerEvents = op < 0.08 ? "none" : "";

        var dist = Math.abs(s - centerSlot);
        var zi = 620 - dist * 48;
        if (s === centerSlot) zi += 200;
        el.style.zIndex = String(zi);

        var side = "side";
        if (s === centerSlot) side = "center";
        if (off >= 2 && u < 0.08) side = "hidden";
        el.setAttribute("data-side", side);
      }

      var cur = slideElByIndex(centerSlideIdx);
      if (counter) {
        counter.removeAttribute("aria-hidden");
        var slideNum = centerSlideIdx + 1;
        counter.textContent = pad2(slideNum);
        var totalSlides = parseInt(counter.getAttribute("data-slide-count"), 10) || n;
        counter.setAttribute("aria-label", "Slide " + slideNum + " of " + totalSlides);
      }

      if (btn && cur) {
        var url = cur.getAttribute("data-url") || "";
        var fallback = btn.getAttribute("href") || "#";
        if (url) btn.setAttribute("href", url);
        else btn.setAttribute("href", fallback);

        var txt = btn.querySelector(".oct__btn-text");
        if (txt) txt.textContent = btnLabelForSlide(cur);

        /* Button color ALWAYS reflects the centered slide (every state) */
        applyBtnColorForSlide(cur);
      }
    }

    function onScroll() {
      if (isMobile()) {
        expand = 1;
        applyLayout();
        return;
      }
      if (root.classList.contains("oct--slot-animating")) clearSlotAnim();
      if (userInteracted) {
        expand = 1;
        applyLayout();
        return;
      }
      var rect = track.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      var total = rect.height - vh;
      var raw = total <= 0 ? 1 : clamp(-rect.top / total, 0, 1);
      expand = clamp(raw * SCROLL_EXPAND_BOOST, 0, 1);
      applyLayout();
    }

    /* CLICK: side card -> bring to center + pause autoplay */
    slides.forEach(function (el) {
      el.addEventListener("click", function () {
        if (isMobile()) return;
        if (root.classList.contains("oct--slot-animating")) return;
        var idx = parseInt(el.getAttribute("data-index"), 10);
        if (isNaN(idx)) return;
        if (slotOfSlide(slots, idx) === centerSlot) return;
        /* Ensure the carousel is in its expanded layout so the
           click-to-center animation always has room to play. */
        userInteracted = true;
        if (expand < 1) {
          expand = 1;
          applyLayout();
        }
        pauseAndResume();
        beginSlotShuffleAnim(idx);
      });
    });

    /* MOBILE NAV: pause autoplay on manual tap */
    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        if (!isMobile() || n <= 1) return;
        pauseAndResume();
        mobileActive = (mobileActive - 1 + n) % n;
        applyLayout();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        if (!isMobile() || n <= 1) return;
        pauseAndResume();
        mobileActive = (mobileActive + 1) % n;
        applyLayout();
      });
    }

    function onResizeViewport() {
      var m = isMobile();
      clearSlotAnim();
      if (lastMobile && !m) syncSlotsFromMobileView();
      if (!lastMobile && m) mobileActive = slots[centerSlot];
      lastMobile = m;
      onScroll();
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onResizeViewport);
    onScroll();

    startAutoplay();

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });

    document.addEventListener("shopify:section:load", function (ev) {
      if (ev.target && ev.target.contains && ev.target.contains(root)) {
        onResizeViewport();
        startAutoplay();
      }
    });

    document.addEventListener("shopify:section:unload", function (ev) {
      if (ev.target && ev.target.contains && ev.target.contains(root)) {
        stopAutoplay();
      }
    });
  }

  document.querySelectorAll("[data-one-craft-tradition]").forEach(init);
})();